import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Roles, RoleService} from "../../../../../core/security";
import {isNullOrUndefined} from "util";


@Component({
    selector: 'tfl-edit-button-group',
    template: `
        <ng-container *ngIf="!isEditing">
            <button (click)="onEdit($event)" class="edit-button btn btn-info btn-sm" [disabled]="isDisabled()">
                {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.EDIT.BUTTON.NAME' | translate }}
            </button>
        </ng-container>

        <ng-container *ngIf="isEditing">
            <button (click)="onDiscard($event)" class="discard-button btn btn-default btn-sm">
                {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.DISCARD.BUTTON.NAME' | translate }}
            </button>
            <button (click)="onSave($event)" class="save-button btn btn-success btn-sm"
                    [disabled]="isSaveDisabled">
                {{'APPLICATIONS.NEW.DETAIL.TAB.DETAILS.SAVE.BUTTON.NAME' | translate }}
            </button>
        </ng-container>
    `
})
export class EditButtonGroupComponent {

    @Input() isEditing = false;
    @Input() isSaveDisabled = true;
    @Input() disabled = false;
    @Input() idPermission : string;

    @Output() edit = new EventEmitter<Event>();
    @Output() discard = new EventEmitter<Event>();
    @Output() save = new EventEmitter<Event>();

    @Input() permission: string;

    constructor(private roleService: RoleService) {
    }
    onEdit(e: Event) {
        e.stopPropagation();
        this.isEditing = true;
        this.edit.emit(e);
    }

    onSave(e: Event) {
        e.stopPropagation();
        if (!this.isSaveDisabled) {
            this.isEditing = false;
            this.save.emit(e);
        }
    }

    onDiscard(e: Event) {
        e.stopPropagation();
        this.isEditing = false;
        this.discard.emit(e);
    }

    isDisabled() {
        if (isNullOrUndefined(this.permission)) {
            return false;
        }
        return !this.roleService.hasElementRoles(Roles.EDIT, this.permission);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/edit-button-group/edit-button-group.component.ts